import React, { ReactNode } from 'react'
import { OidcProvider } from '@axa-fr/react-oidc'
import { useRouter } from 'next/router'
import { oidcConfiguration } from '../src/Infrastructure/Configuration/IdentityConfiguration'
import { ErrorView } from '../src/Component/Error/Error'
import { LoadingView } from '../src/Component/Loading/Loading'

export default function Layout({ children }: { children: ReactNode }) {
  const router = useRouter()
  const withCustomHistory = () => {
    return {
      replaceState: (url: string) => {
        router
          .replace({
            pathname: url,
          })
          .then(() => {
            window.dispatchEvent(new Event('popstate'))
          })
      },
    }
  }
  return (
    <>
      <OidcProvider
        loadingComponent={() => <LoadingView message="Authenticating" />}
        authenticatingComponent={() => <LoadingView message="Authenticating" />}
        sessionLostComponent={() => <ErrorView message="Authentication session expired" />}
        configuration={oidcConfiguration}
        withCustomHistory={withCustomHistory}
      >
        <main>{children}</main>
        <footer className="text-center small mt-5">Version: v1.18.6</footer>
      </OidcProvider>
    </>
  )
}
